export enum FinancialCreditClientOriginEnum {
    BILL_INSTALLMENT = 'Contas a receber',
    CLIENT_RETURN = 'Devolução de venda',
    MANUAL = 'Lançamento manual',
    SALE = 'Venda',
}

export type FinancialCreditClientOrigin = keyof typeof FinancialCreditClientOriginEnum;
